const { REACT_APP_CONTEXT_PATH } = process.env;

const chatbotInitForNobrandApi = () => {
  return {
    apiUrl: REACT_APP_CONTEXT_PATH + `/channel-log`,
  };
};

export default chatbotInitForNobrandApi;
